import { IReportService } from "../../service/report/ReportService";

export default class GetReport8ApplicantsInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(fullName: string) {
    return this.reportService.getReport8ApplicantList(fullName);
  }
}
